import React, { useState } from 'react';
import { NavLink } from 'react-router-dom';
import { FiBriefcase, FiGrid, FiMapPin, FiUsers, FiMenu, FiUser } from 'react-icons/fi';
import { hasPermission as checkPermission } from '../../utils/permissions';
import './style.css';

export default function BottomTabNavigator({ onMenuClick, isMenuOpen }) {
  const [user] = useState(() => {
    try {
      return JSON.parse(localStorage.getItem('authUser'));
    } catch (e) {
      return null;
    }
  });

  const hasPermission = (moduleName) => {
    return checkPermission(user, moduleName);
  };

  const links = [
    { to: '/', label: 'Início', icon: FiGrid, permission: null },
    { to: '/companies', label: 'Empresas', icon: FiBriefcase, permission: 'companies' },
    { to: '/sub-users', label: 'Usuários', icon: FiUser, permission: 'sub_users' },
    { to: '/stations', label: 'Postos', icon: FiMapPin, permission: 'management' },
    { to: '/employees', label: 'Funcionários', icon: FiUsers, permission: 'management' },
  ].filter(link => !link.permission || hasPermission(link.permission));

  return (
    <nav className="bottom-tab-navigator">
      {links.map(link => {
        const Icon = link.icon;

        return (
          <NavLink
            key={link.to}
            to={link.to}
            className={({ isActive }) =>
              [
                'bottom-tab-item',
                isActive && !isMenuOpen && 'active',
              ]
                .filter(Boolean)
                .join(' ')
            }
          >
            <Icon size={20} />
            <span>{link.label}</span>
          </NavLink>
        );
      })}
      
      <button
        type="button"
        className={[
          'bottom-tab-item',
          isMenuOpen && 'active',
        ]
          .filter(Boolean)
          .join(' ')}
        onClick={onMenuClick}
      >
        <FiMenu size={20} />
        <span>Menu</span>
      </button>
    </nav>
  );
}
